/* eslint-disable no-undef */

import React, { Component } from 'react'
import DateQuestion from './questionTypes/Date'
import TextQuestion from './questionTypes/Text'
import EmailQuestion from './questionTypes/Email'
import CompanySelectQuestion from './questionTypes/CompanySelect'
import { withStyles } from '@material-ui/core/styles/index'
import SliderQuestion from './questionTypes/Slider'
import SelectButtonsQuestion from './questionTypes/SelectButtons'
import RadioButtonsQuestion from './questionTypes/RadioButtons'
import CheckboxesQuestion from './questionTypes/Checkboxes'
import ImageButtonsQuestion from './questionTypes/ImageButtons'
import UploadQuestion from './questionTypes/Upload'

const styles = theme => ({
    question: {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(3)
    }
})

class Question extends Component {
    state = { value: null }

    componentDidMount() {
        const { question, value } = this.props
    }

    render() {
        const { question, value, classes, onValueChanged, className, visitorSessionId, theme } = this.props

        return (
            <>
                {question.type === 'email' && <EmailQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />}
                {question.type === 'date' && <DateQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />}
                {question.type === 'text' && <TextQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />}
                {question.type === 'selectButtons' && (
                    <SelectButtonsQuestion question={question} value={value} onValueChanged={onValueChanged} className={className} theme={theme} />
                )}
                {question.type === 'radioButtons' && (
                    <RadioButtonsQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />
                )}
                {question.type === 'checkboxes' && (
                    <CheckboxesQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />
                )}
                {question.type === 'imageButtons' && (
                    <ImageButtonsQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />
                )}
                {question.type === 'companySelect' && (
                    <CompanySelectQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />
                )}
                {question.type === 'slider' && <SliderQuestion question={question} value={value} onValueChanged={onValueChanged} theme={theme} />}
                {question.type === 'upload' && (
                    <UploadQuestion
                        question={question}
                        value={value}
                        onValueChanged={onValueChanged}
                        visitorSessionId={visitorSessionId}
                        theme={theme}
                    />
                )}
            </>
        )
    }
}

export default withStyles(styles)(Question)
